import axios from "axios";
import { getCookie } from "../utils/service";

const Axioscall = axios.create({
  // baseURL: "http://13.233.21.230:3000/v1/",
  baseURL: "https://salesservices.codelynks.in/v1"
});

Axioscall.interceptors.request.use((req) => {
  const accessToken = getCookie("x-access-token");
  req.headers.Authorization = accessToken ? `${accessToken}` : "";
  return req;
});
export default Axioscall;
